import axios from 'axios';
import { serviceUrl } from '../../App';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getShiftWorkbenchSettings = (type: string) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/settings?where=` + type
  );
};
export const AddShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/settings/create`,
    obj,
    { headers }
  );
};

export const EditShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/settings/edit`,
    obj,
    { headers }
  );
};

export const DeleteShiftWorkbenchSettings = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift-workbench/settings/delete`,
    obj,
    { headers }
  );
};
